// import config from "./config";
import { authHeader } from "../helpers/authHeader.js";
import Axios from "axios";
import { tools } from "../helpers";
import { config } from "../helpers";

export const priceService = {
  calculatePrice
};

async function calculatePrice(booking) {
  const vehicleType = booking.vehicle_type
    ? booking.vehicle_type.external_key
    : "";

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      client: booking.account.id,
      password: config.bookingAPIPwd
    }
  };

  const goods = [];

  if (booking.goods) {
    booking.goods.forEach(goodsItem => {
      goods.push({
        cll: tools.parseDouble(goodsItem.cll),
        grossweight: tools.parseDouble(goodsItem.weight),
        description: encodeURI(goodsItem.description),
        adr: goodsItem.adr,
        slv: goodsItem.slv,
        pipes: goodsItem.pipes
      });
    });
  }

  const body = {
    booking: {
      customerno: booking.account.id,
      // 'cartype': vehicleType != null ? vehicleType.externalKey : -1,
      cartype: vehicleType,
      insuranceamount: booking.insurance
        ? tools.parseDouble(booking.insurance_amount)
        : 0.0,
      stops: [
        {
          stoporder: 0,
          // address: {
          //   name1: encodeURI(booking.pickup.address.name),
          //   address1: encodeURI(booking.pickup.address.address),
          //   zip: booking.pickup.address.zip,
          //   city: encodeURI(booking.pickup.address.city),
          //   countrycode: encodeURI(booking.pickup.address.country)
          // },
          address: {
            name1: booking.pickup.address.name,
            address1: booking.pickup.address.address,
            zip: booking.pickup.address.zip,
            city: booking.pickup.address.city,
            countrycode: booking.pickup.address.country
          },
          fromtime:
            booking.pickup.timewindow.from.date +
            "T" +
            booking.pickup.timewindow.from.time +
            ":00.000",
          totime:
            booking.pickup.timewindow.to.date +
            "T" +
            booking.pickup.timewindow.to.time +
            ":00.000"
        },
        {
          stoporder: 1,
          address: {
            name1: booking.delivery.address.name,
            address1: booking.delivery.address.address,
            zip: booking.delivery.address.zip,
            city: booking.delivery.address.city,
            countrycode: booking.delivery.address.country
          },
          fromtime:
            booking.delivery.timewindow.from.date +
            "T" +
            booking.delivery.timewindow.from.time +
            ":00.000",
          totime:
            booking.delivery.timewindow.to.date +
            "T" +
            booking.delivery.timewindow.to.time +
            ":00.000"
        }
      ],
      goods: goods
    }
  };

  let price;

  // tools.logAxios(
  //   `${config.apiUrlBooking_PriceEndpoint}/requestPrice`,
  //   body,
  //   requestOptions
  // );

  await Axios.post(
    `${config.apiUrlBooking_PriceEndpoint}/requestPrice`,
    body,
    requestOptions
  )
    .then(handleResponse)
    .then(
      response => {
        price = response;
      },
      error => {
        return error;
      }
    );

  // determine if timeflex is applicable
  if (price != null && price.result != null && price.result.price != null) {
    await isApplicableForTimeFlex(booking, price.result.price).then(
      response => {
        price.result.price["applicablefortimeflex"] = response;
      },
      error => {
        console.error(error);
      }
    );
  }

  let waitingTimeParameters = null;

  const customerId = booking.account.id;

  const timestamp =
    booking.pickup.timewindow.from.date +
    "T" +
    booking.pickup.timewindow.from.time +
    ":00.000";

  await loadWaitingTimeParameters(customerId, timestamp, vehicleType).then(
    response => {
      waitingTimeParameters = response;
    },
    error => {
      console.error(error);
    }
  );

  await groupPriceDetails(price, waitingTimeParameters);

  return price;
}

// function getVehicleType(id) {
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader(),
//     };

//     return Axios.get(`${config.apiUrlPrice}/Price/GetVehicleType?id=` + id, requestOptions).then(handleResponse);
// }

function isApplicableForTimeFlex(booking, price) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };

  const body = {
    customerid: booking.account.id,
    pricetype: price != null ? price.pricetype : "",
    from:
      booking.pickup.timewindow.from.date +
      "T" +
      booking.pickup.timewindow.from.time +
      ":00.000",
    to:
      booking.pickup.timewindow.to.date +
      "T" +
      booking.pickup.timewindow.to.time +
      ":00.000",
    serviceTypeExternalKey: booking.vehicle_type.external_key
  };

  // tools.logAxios(
  //   `${config.apiUrlPrice}/Price/IsApplicableForTimeFlex`,
  //   body,
  //   requestOptions
  // );

  return Axios.post(
    `${config.apiUrlPrice}/Price/IsApplicableForTimeFlex`,
    body,
    requestOptions
  ).then(handleResponse);
}

function loadWaitingTimeParameters(customerId, timestamp, vehicleType) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };

  const body = {
    customerId: customerId,
    timestamp: timestamp,
    vehicleType: vehicleType
  };

  return Axios.post(
    `${config.apiUrlTools}/Authorize/LoadWaitingTimeParameters`,
    body,
    requestOptions
  ).then(handleResponse);
}

function groupPriceDetails(price, waitingTimeParameters) {
  if (price) {
    let totalchargeprice = 0.0;
    let chargedetails = [];

    // init pricegroups
    price.result.price["transportprice"] = {
      description: "Turpris",
      price: null,
      currency: null,
      pricedetailtype: "TRANSPORT_PRICE",
      remark: null
    };
    price.result.price["waitingprice"] = {
      description: "Ventetid",
      price: null,
      currency: null,
      pricedetailtype: "WAITING_CHARGE",
      remark: null
    };

    if (
      waitingTimeParameters &&
      waitingTimeParameters.waitingTimeEnabled &&
      waitingTimeParameters.waitingTimeSec > 0
    ) {
      price.result.price.waitingprice.description =
        waitingTimeParameters.waitingTimeSec / 60 +
        " min. vente-/læssetid pr. stop (derefter " +
        tools.parseDoubleToString(waitingTimeParameters.pricePerMin) +
        " " +
        waitingTimeParameters.currency +
        " pr. min.)";
    }

    price.result.price.details.forEach(pricedetail => {
      if (pricedetail && pricedetail.pricedetailtype == "TRANSPORT_PRICE") {
        price.result.price.transportprice = Object.assign({}, pricedetail);

        price.result.price.transportprice.description = "Turpris";
        price.result.price.transportprice.remark =
          pricedetail.description +
          (pricedetail.description && pricedetail.remark ? " (" : "") +
          pricedetail.remark +
          (pricedetail.description && pricedetail.remark ? ")" : "");
      } else if (
        pricedetail &&
        pricedetail.pricedetailtype == "WAITING_CHARGE"
      ) {
        price.result.price.waitingprice = Object.assign({}, pricedetail);
      } else {
        totalchargeprice += parseFloat(pricedetail.price);
        chargedetails.push(Object.assign({}, pricedetail));
      }
    });
    price.result.price["totalchargeprice"] = totalchargeprice;
    price.result.price["chargedetails"] = chargedetails;
  }
}

function handleResponse(response) {
  if (response.status != "200") {
    const error = response.statusText;
    return Promise.reject(error);
  }
  return response.data;
}
